var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"all-post-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-12"},[_vm._l((_vm.category_news),function(category,index){return [_c('entertainment-news',{key:index,attrs:{"category_news":category,"darkClass":{
						item: 'trending-news-item-dark',
						title: 'section-title-2',
					}}})]})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }